import {
    type FC
} from "react";
import type IChartGridProps from "./type";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    Line,
    G
} from "react-native-svg";

const ChartGrid: FC<IChartGridProps> = ({
    orientation = "horizontal",
    customTheme,
    positions,
    baseline,
    plot
}) => {
    const {
        borders,
        colors
    } = NCoreUIKitTheme.useContext(customTheme);

    const isHorizontal = orientation === "horizontal";

    const renderLine = (position: number, color: string) => {
        return <Line
            y2={isHorizontal ? position : plot.y + plot.height}
            x2={isHorizontal ? plot.x + plot.width : position}
            y1={isHorizontal ? position : plot.y}
            x1={isHorizontal ? plot.x : position}
            key={`${position}-${color}`}
            strokeWidth={borders.line}
            stroke={color}
        />;
    };

    return <G
        aria-hidden={true}
    >
        {positions.map((position) => renderLine(position, colors.content.border.subtle))}
        {baseline === undefined ? null : renderLine(baseline, colors.content.border.default)}
    </G>;
};
export default ChartGrid;
